<template>
  <v-form ref="form" lazy-validation>
    <v-row>
      <v-col cols="4">
        <v-text-field
          dense
          label="Nome"
          type="text"
          v-model="coverage.name"
          :rules="typeForm === 'new' || typeForm === 'edit' ? [$util.formrules.required] : []"
          :error-messages="typeForm === 'new' || typeForm === 'edit' ? errors.name : null"
          outlined
        />
      </v-col>
      
      <v-col cols="4" v-if="!isListView">
        <v-text-field
          dense
          label="Código"
          type="text"
          v-model="coverage.code"
          outlined
        />
      </v-col>
      
      <v-col cols="4">
        <v-autocomplete
          dense
          outlined
          v-model="coverage.recordTypeId"
          :items="recordTypes"
          item-text="name"
          item-value="id"
          label="Tipo de Registro"
          :rules="typeForm === 'new' || typeForm === 'edit' ? [$util.formrules.requiredSelected] : []"
          validate-on-blur
          hide-details="true"
        />
      </v-col>
      <v-col cols="4">
        <coverage-descriptions
          :item="coverage"
          :typeForm="typeForm"
          :coverage-descriptions="getCoverageDescriptions"
          @on-description-created="updateCoverage"
        >
        </coverage-descriptions>
      </v-col>
      <v-col cols="4">
        <v-checkbox
          :disabled="coverage.allAnsExecutiveDifferential"
          dense
          label="Selecionar Cobertura ANS"
          v-model="coverage.is_ans_coverage"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-checkbox
          :disabled="coverage.allAnsExecutiveDifferential"
          dense
          label="Selecionar Diferencial Executivo"
          v-model="coverage.is_executive_differential"
          outlined
        />
      </v-col>

      <v-col cols="4" v-if="!isListView">
        <v-autocomplete
          dense
          outlined
          v-model="coverage.groupId"
          :items="getCoverageGroups"
          item-text="name"
          item-value="id"
          label="Grupo de Cobertura"
          validate-on-blur
          hide-details="true"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import CoverageDescriptions from "@/view/coverage/coverage_descriptions.vue";
import RecordTypeService from "@/services/odoo/RecordTypeService";

export default {
  components: { CoverageDescriptions},
  props: {
    coverage: {
      type: Object
    },
    errors: {
      type: Object
    },
    typeForm: String,
    options: Object,
    isListView: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      items: [],
      recordTypes: [],
      coverageGroups: [],
    };
  },

  mounted() {
    this.loadData();
  },
  computed: {
    ...mapGetters('coverage', ['getCoverageDescriptions', 'getCoverageGroups']),
  },
  async created() {
    this._recordTypeService = new RecordTypeService();
  },
  methods: {
    ...mapActions('coverage', ['fetchCoverageDescriptions', 'fetchRecordTypes', 'fetchCoverageGroups']),
    validate() {
      return this.$refs.form.validate();
    },
    async loadData() {
      this._recordTypeService.findAllByModel('xipp.coverage').then((res) => {
        if (res && res.data && res.data.records && res.data.records.length > 0) {
          this.recordTypes = res.data.records;
        }
        });
      await this.fetchCoverageDescriptions().then();
      await this.fetchCoverageGroups().then();
    },
    async updateCoverage(coverage, coverageDescriptionId) {
      this.coverage.ruleId = coverageDescriptionId;
    },
    model() {
      return this.coverage;
    },
    goBack() {
      this.$router.back()
    },
    changeAll() {
      if(this.coverage.allAnsExecutiveDifferential) {
        this.coverage.is_executive_differential = false;
        this.coverage.is_ans_coverage = false;
      }
    }
  }
};
</script>


